module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud1-050161300d80ef17a9a2362eec0632f9.svg";